import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_ai_template} from "../components/templates/config_ai_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_ai extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected configAi: config_ai_template;
    protected _isLeavePageWarningNeeded: boolean = true;

    public fillPage() {
        this.getGeneralConfigData()
    }

    buildContent(): Array<Element> {
        this.configAi = new config_ai_template("config_ai", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Ai Settings");

        return [this.configAi.build()];
    }

    protected getModuleName(): string {
        return "config_ai";
    }

    private getGeneralConfigData() {
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/generalconfig/ai-settings/get/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetGeneralConfigDataReturn;
        this.XHRHdl.execute();
    }

    private onGetGeneralConfigDataReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                let response = responseParsed.data;

                obj.configAi.setAiSettings(response.aiSettings);
               
            });
        }
    }

    public filterDropdownOnChange(data) {
        // dropdowns cry without this, we don't really need it
    }

    protected saveAiSettings(param, data) {
        this.loadingIn(this.configAi.builtTemplate);
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/generalconfig/ai-settings/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.configAi.getAiSettings()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {


            let responseParsed = JSON.parse(req.request.response);
            // Render summaries
            obj.renderSummaries(responseParsed);

            // obj.manageResponse(req, obj, function () {

            //     let idBrand = obj.getVnAppZone().getApp().params.idBrand;
            //     page.redirect("/brand/"+idBrand+"/config/ai/");

            // });
             obj.loadingOut(obj.configAi.builtTemplate);
            //  obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "SAVED!");

            }
        });
        XHRHdl.execute();
    }
    private renderSummaries(response: any): void {
        const container = document.getElementById("ai-summaries-container");
        if (!container) return;

        container.innerHTML = `
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Simple Summary</h4>
                <div class="ai-summary-content">${response.simpleSummary || ""}</div>
            </div>
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Factual Summary</h4>
                <div class="ai-summary-content">${response.factualSummary || ""}</div>
            </div>
            <div class="ai-summary-block" style="border: 1px solid #ccc; margin: 10px 0; padding: 10px;">
                <h4>Satirical Commentary</h4>
                <div class="ai-summary-content">${response.satiricalCommentary || ""}</div>
            </div>

            <style>
                 .ai-summary-content {
                        background-color: $white;
                        border-radius: $border-radius-block;
                        padding: 1.25rem;
                        margin: 1rem;
                        position: relative;
                        transition: height .5s ease;

                        @include tablet {
                            padding: 1.75rem;
                            margin: 1.25rem;
                        }

                        @include dark-mode {
                            background-color: $theme-dark-body-bg-color;
                        }

                        .ai-summary  {
                            margin-top: 1.25rem;

                            /* Title */
                            h2 {
                                font-size: 1.5rem;
                                font-weight: 600;
                                margin-bottom: 1rem;
                            }

                            h3 {
                                font-size: 1.25rem;
                                font-weight: 500;
                                margin-bottom: 1rem;
                            }

                            p {
                                @include font-style(1rem, 400, $web-color-6);
                                line-height: 1.5;
                                margin-bottom: 1rem;

                                &:last-of-type {
                                    margin-bottom: 0;
                                }
                            }

                            ul, ol {
                                @include font-style(1rem, 400, $web-color-6);
                                line-height: 1.5;
                                padding-left: 1rem;
                                margin: 1.25rem;

                                li {
                                    margin-bottom: 0.5rem;
                                }
                            }

                            ul li {
                                list-style-type: disc;
                            }

                            ol li {
                                list-style-type: unset;
                            }


                            strong {
                                font-weight: bold;
                            }

                            em {
                                font-style: italic;
                            }

                            @include dark-mode {
                                * {
                                    color: $theme-dark-reading-text;
                                }
                            }
                        }

                        // Animation CSS
                        .hidden-remaining {
                            visibility: hidden;
                            opacity: 0;
                        }
                        .blurred-full {
                            filter: blur(20px);
                            color: transparent;
                            pointer-events: none;
                            user-select: none;
                        }
                        .blurred-current {
                            filter: blur(4px);
                            color: gray;
                            pointer-events: none;
                            user-select: none;
                        }
                    }

            </style>
        `;
    }

    protected cancelSiteSettings() {
        this.backAction()
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "AI SETTINGS changes cancelled!");
    }

    protected backAction(){
        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect("/brand/"+idBrand+"/config/ai/");
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_ai.ts